import React from 'react'
import PropTypes from 'prop-types'
import { ImgSkill } from '../../../../../styles/atoms/StyledComponents'

const ImageSkill = ({url, altText}) => {
  return (
    <ImgSkill
      src={url}
      alt={altText}
    />
  )
}

ImageSkill.propTypes = {
  url: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
}

export default ImageSkill
